import Vue from 'vue'
import store from './store'
import StudentExchangeOverviewWidget from './StudentExchangeOverviewWidget.vue'
import VueCompositionAPI from '@vue/composition-api'
import { getAttributeValue } from "@/shared/filters/utils-filter"

Vue.config.productionTip = false
Vue.use(VueCompositionAPI)

let widgetEls = document.querySelectorAll('student-exchange-overview-widget')

if (widgetEls.length) {
    widgetEls.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                return h(StudentExchangeOverviewWidget, {
                    props: {
                        labels: getAttributeValue(el, 'labels', true),
                        language: getAttributeValue(el, 'language')
                    }
                })
            }
        })
    })
}
